import React from "react";
import { cn } from "../../lib/utils";
import { Button } from "../../components/ui/button";
// import { ScrollArea } from "@/components/ui/scroll-area";
import {
  UserIcon,
  Boxes,
  Key,
  Percent,
  Building2,
  CreditCard,
  ChartColumnIncreasing,
} from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Sidebar({ className }: SidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const routes = [
    {
      label: "Analytics",
      icon: ChartColumnIncreasing,
      href: "/analytics",
    },
    {
      label: "Users",
      icon: UserIcon,
      href: "/users",
    },
    {
      label: "Assets",
      icon: Boxes,
      href: "/assets",
    },
    {
      label: "Rentals",
      icon: Key,
      href: "/rental",
    },
    {
      label: "Update Yields Details",
      icon: Percent,
      href: "/update-yields",
    },
    // {
    //   label: 'Update Resell Price',
    //   icon: ChartColumnIncreasing,
    //   href: '/update-resell-price',
    // },
    {
      label: "Amenities",
      icon: Building2,
      href: "/amenities",
    },

    {
      label: "Transactions",
      icon: CreditCard,
      href: "/transactions",
    },
  ];

  return (
    <div className={cn("pb-8", className)}>
      <div className="space-y-3 py-3">
        <div className="px-2 py-1">
          <h2 className="mb-2 px-3 text-base font-semibold">Dashboard</h2>
          {/* <ScrollArea className="px-1"> */}
          <div className="space-y-1">
            {routes.map((route) => (
              <Button
                key={route.href}
                variant={
                  location.pathname.startsWith(route.href)
                    ? "secondary"
                    : "ghost"
                }
                className="w-full justify-start text-sm text-surface-2"
                onClick={() => navigate(route.href)}
              >
                <route.icon className="mr-2 h-3.5 w-3.5 text-surface-2" />
                {route.label}
              </Button>
            ))}
          </div>
          {/* </ScrollArea> */}
        </div>
      </div>
    </div>
  );
}
